

function BoxSlider({ image }) {
    return (
        <div className="p-2 2xl:w-56 xl:w-52 w-40">
            <img
                src={image}
                className="rounded-lg shadow "
            />
        </div>
    )
}
export default BoxSlider;